import { IconButton } from '@mui/material'
import IcBaselineKeyboardArrowLeft from '~icons/ic/baseline-keyboard-arrow-left'
import IcBaselineKeyboardArrowRight from '~icons/ic/baseline-keyboard-arrow-right'
import type { PageInfo } from 'src/services/apollo/generated/graphql'
import type { OnCursorChange } from '../CursorPaging/CursorPagingButton'

export default function TablePaginationActionsWrapper(
  props: {
    pageInfo?: PageInfo
    onCursorChange?: OnCursorChange
    isPosSeq?: boolean
  } & StyleProps,
) {
  const { pageInfo, onCursorChange = () => {}, isPosSeq } = props

  const handleBackButtonClick = () => {
    onCursorChange(
      isPosSeq
        ? {
            before: pageInfo?.startCursor,
            after: undefined,
          }
        : {
            before: undefined,
            after: pageInfo?.endCursor,
          },
    )
  }

  const handleNextButtonClick = () => {
    onCursorChange(
      isPosSeq
        ? {
            before: undefined,
            after: pageInfo?.endCursor,
          }
        : {
            before: pageInfo?.startCursor,
            after: undefined,
          },
    )
  }

  return (
    <div className={props.className}>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={
          isPosSeq ? !pageInfo?.hasPreviousPage : !pageInfo?.hasNextPage
        }
        aria-label="previous page"
      >
        <IcBaselineKeyboardArrowLeft className="size-6" />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={
          isPosSeq ? !pageInfo?.hasNextPage : !pageInfo?.hasPreviousPage
        }
        aria-label="next page"
      >
        <IcBaselineKeyboardArrowRight className="size-6" />
      </IconButton>
    </div>
  )
}
